export const stringToUint8Array = (str: string): Uint8Array => {
  const encoder = new TextEncoder();

  // Encode a string to a Uint8Array
  const uint8Array = encoder.encode(str);
  return uint8Array;
};

export const numberToHexString = (num: number): string => {
  return `0x${num.toString(16)}`;
};

export function countLeadingZeros(num: number): number {
  // Convert the number to a string
  let numStr = num.toString();

  // Split the string on the decimal point
  let parts = numStr.split('.');

  // If there's no decimal point or if the number is an integer, there are no leading zeros
  if (parts.length < 2) {
    return 0;
  }

  // Get the fractional part of the number
  let fractionalPart = parts[1];

  // Count the leading zeros in the fractional part
  let leadingZeros = 0;
  for (let char of fractionalPart) {
    if (char === '0') {
      leadingZeros++;
    } else {
      break;
    }
  }

  return leadingZeros;
}

export function firstNonZeroValue(num: number): string | null {
  // Convert the number to a string
  let numStr = num.toString();

  // Split the string on the decimal point
  let parts = numStr.split('.');

  // If there's no decimal point or if the number is an integer, return null
  if (parts.length < 2) {
    return null;
  }

  // Get the fractional part of the number
  let fractionalPart = parts[1];

  // Iterate over the characters in the fractional part
  for (let char of fractionalPart) {
    if (char !== '0') {
      return char;
    }
  }

  // If all values in the fractional part are zeros, return null
  return null;
}
